module.exports = "<div class=\"report-status-row\" data-source=\"{{Model.Source}}\">\r\n    <!-- <a href=\"importstatus/{{Model.FilesOutstanding}}\"> -->\r\n        <div class=\"data-source\">\r\n            {{Model.Source}}\r\n        </div>\r\n        <div class=\"files-outstanding {{#Model.FilesOutstanding}}outstanding{{/Model.FilesOutstanding}}\">\r\n            {{Model.FilesOutstanding}}\r\n        </div>\r\n        <div class=\"last-processed\">\r\n            {{Model.LatestFileAdded}}\r\n        </div>\r\n    <!-- </a> -->\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/import-status/views/report-status.html
// module id = 364
// module chunks = 1